import React from 'react'
import { Dialog, DialogContent, DialogTitle, Grid } from '@material-ui/core'
import { AccountCircle } from '@material-ui/icons'
import { grey } from '@material-ui/core/colors'

function UserProfileCard({ open, handleClose, userProfile }) {

  const { name } = userProfile

  return (
    open &&
    <Dialog open={open} onClose={handleClose} maxWidth='xs' fullWidth>
      <DialogTitle>
        <Grid container alignItems='center' justifyContent='flex-start'>
          <Grid container item xs={2} justifyContent='center' alignItems='center'>
            {/* <img alt='account-avatar' className={classes.avatar} style={{ display: 'block' }}
              src={`data:image/png;base64,${new Identicon((userId.length >= 15 ? userId : userId + 'abcdefghijklmnop'), 40).toString()}`}
            /> */}
            <AccountCircle style={{ color: grey[500], fontSize: 40 }} />
          </Grid>
          <Grid item xs='auto'>
            {name}
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} style={{ paddingBottom: 16 }}>
          {/* {gender &&
            <Grid item xs={12}>
              <Typography variant='body2'>
                <strong>{'Gender: '}</strong>
                {gender}
              </Typography>
            </Grid>
          } */}
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default UserProfileCard
